import { Injectable } from '@angular/core';

@Injectable()
export class ServiceFormValidatorService {

    /**
     * Validate that origin location is filled
     */
    public validateOrigin(servicio: any): {valid: boolean, message: string} {
        if (!servicio.origen || servicio.origen === "") {
            return {
                valid: false,
                message: 'Debes seleccionar un lugar de Origen'
            };
        }
        return {valid: true, message: ''};
    }

    /**
     * Validate that destination location is filled
     */
    public validateDestination(servicio: any): {valid: boolean, message: string} {
        if (!servicio.destino || servicio.destino === "") {
            return {
                valid: false,
                message: 'Debes seleccionar un lugar de Destino'
            };
        }
        return {valid: true, message: ''};
    }

    /**
     * Validate that arrival time is not before departure time
     */
    public validateDateRange(departureTime: number, arrivalTime: number): {valid: boolean, message: string} {
        if (arrivalTime < departureTime) {
            return {
                valid: false,
                message: 'La fecha de llegada no debe ser anterior a la de salida.'
            };
        }
        return {valid: true, message: ''};
    }

    /**
     * Validate service origin and destination
     * Comprehensive validation including all location checks
     */
    public validateServiceLocations(servicio: any, departureTime: number, arrivalTime: number): {
        valid: boolean;
        message: string;
    } {
        const originValidation = this.validateOrigin(servicio);
        if (!originValidation.valid) {
            return originValidation;
        }

        const destinationValidation = this.validateDestination(servicio);
        if (!destinationValidation.valid) {
            return destinationValidation;
        }

        const dateRangeValidation = this.validateDateRange(departureTime, arrivalTime);
        if (!dateRangeValidation.valid) {
            return dateRangeValidation;
        }

        return {valid: true, message: ''};
    }

    /**
     * Validate unit combinations are properly filled
     * Ensures each combination has at least one unit selected
     */
    public validateUnitCombinations(combinaciones: any[]): {valid: boolean, message: string} {
        if (!combinaciones || combinaciones.length === 0) {
            return {
                valid: false,
                message: 'Debes agregar al menos una combinación de unidades'
            };
        }

        for (const combinacion of combinaciones) {
            let hasUnits = false;
            for (const key in combinacion) {
                if (combinacion.hasOwnProperty(key) && combinacion[key] > 0) {
                    hasUnits = true;
                    break;
                }
            }
            if (!hasUnits) {
                return {
                    valid: false,
                    message: 'Por favor revisa las combinaciones de unidades, existe un error o hacen falta datos'
                };
            }
        }

        return {valid: true, message: ''};
    }

    /**
     * Validate additional concepts (conceptos adicionales)
     * Ensures all concepts have proper descriptions and prices
     */
    public validateAdditionalConcepts(conceptos: any[]): {valid: boolean, message: string} {
        if (!conceptos || conceptos.length === 0) {
            return {valid: true, message: ''};
        }

        for (const concepto of conceptos) {
            if (!concepto.nombre || concepto.nombre.trim() === '') {
                return {
                    valid: false,
                    message: 'Por favor revisa cada descripción de los conceptos adicionales'
                };
            }
            if (!concepto.precio || concepto.precio <= 0) {
                return {
                    valid: false,
                    message: 'Por favor revisa cada precio de los conceptos adicionales'
                };
            }
        }

        return {valid: true, message: ''};
    }

    /**
     * Validate that an origin office is selected
     */
    public validateOriginOffice(servicio: any): {valid: boolean, message: string} {
        if (!servicio.oficinaDeOrigen || servicio.oficinaDeOrigen === "") {
            return {
                valid: false,
                message: 'Debes seleccionar una oficina de origen'
            };
        }
        return {valid: true, message: ''};
    }

    /**
     * Validate complete service form
     * Returns first validation error found
     */
    public validateCompleteServiceForm(params: {
        servicio: any;
        departureTime: number;
        arrivalTime: number;
        combinaciones: any[];
        conceptosAdicionales: any[];
    }): {valid: boolean, message: string} {
        
        const locationValidation = this.validateServiceLocations(
            params.servicio, 
            params.departureTime, 
            params.arrivalTime
        );
        if (!locationValidation.valid) {
            return locationValidation;
        }

        const officeValidation = this.validateOriginOffice(params.servicio);
        if (!officeValidation.valid) {
            return officeValidation;
        }

        const combinationValidation = this.validateUnitCombinations(params.combinaciones);
        if (!combinationValidation.valid) {
            return combinationValidation;
        }

        const conceptsValidation = this.validateAdditionalConcepts(params.conceptosAdicionales);
        if (!conceptsValidation.valid) {
            return conceptsValidation;
        }

        return {valid: true, message: ''};
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/validators/service-form-validator.service.ts